import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    FileActivityModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class FileActivitiesDataService implements CrudService<FileActivityModel, FileActivityModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<FileActivityModel>): Promise<CrudListResponse<FileActivityModel>> {
        return ApiService.api.getFileActivityBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<FileActivityModel>> {
        return ApiService.api.getFileActivityById(id, params);
    }

    create(item: FileActivityModel, params?: RequestParams): Promise<CrudResponse<FileActivityModel>> {
        return ApiService.api.insertFileActivity(item, params);
    }

    update(item: FileActivityModel, params?: RequestParams): Promise<FileActivityModel> {
        return ApiService.api.updateFileActivity(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<FileActivityModel> {
        return ApiService.api.patchFileActivity(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<FileActivityModel>): Promise<CrudListResponse<FileActivityModel>> {
        return ApiService.api.deleteFileActivities(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<FileActivityModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
